exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bg-challenge-gray[data-v-31d2cf3a]{background-color:#bdbdbd!important}.img-icon[data-v-31d2cf3a]{width:14px;height:14px}", ""]);

// exports
